<template>
    <ReviewForm/>
  </template>
  
  <script>
  /* eslint-disable */
import ReviewForm from '@/components/ReviewForm.vue';

export default {
  name: 'ReviewView',   
    components: {
        ReviewForm
    }
};

  </script>
  